import { ENetwork } from '@NGUtils/enums';
import { isStarknetActivated } from '@functions/featureFlag';
import { EStarknetChainId, EWalletId, EWalletType } from './web3Store.enums';
import { INetwork, TWallets } from './web3Store.type';

const SAVED_USER_ADDRESS_KEY = 'saved-user-address';

const CONNECTED_WEB3_ACCOUNTS_KEY = 'connected-web3-accounts';

const defaultProvider = { error: true };

const WALLETS: {
	[key in EWalletId]: TWallets;
} = {
	[EWalletId.blocknative]: {
		id: EWalletId.blocknative,
		name: 'BlockNative',
		buttonLabel: 'Connect Your Wallet',
		type: EWalletType.ethereum,
		isInstalled: true
	},
	[EWalletId.argentX]: {
		id: EWalletId.argentX,
		logoSrc: '/assets/wallets/logo-argent-x.svg',
		name: 'Argent X',
		type: EWalletType.starknet,
		isInstalled: false,
		downloadUrl: ''
	},
	[EWalletId.braavos]: {
		id: EWalletId.braavos,
		name: 'Braavos',
		logoSrc: '/assets/wallets/logo-braavos.svg',
		type: EWalletType.starknet,
		isInstalled: false,
		downloadUrl: ''
	}
};

// if !isStarknetActivated() remove wallet with type starknet
const WALLETS_ARRAY = Object.values(WALLETS).filter((wallet) => {
	if (wallet.type === EWalletType.starknet) return isStarknetActivated();

	return true;
});

const NETWORKS_DATA: { [key in ENetwork]: INetwork } = {
	[ENetwork.goerli]: {
		id: 'goerli',
		name: 'Goerli',
		ticker: 'GETH',
		rpc: process.env.RPC_GOERLI || '',
		chainId: 5,
		decimals: 18,
		explorerUrl: 'https://goerli.etherscan.io/'
	},
	[ENetwork.starknetGoerliAlpha]: {
		id: 'starknet-goerli-alpha',
		name: 'Starknet Testnet 1',
		ticker: 'GETH',
		chainId: EStarknetChainId.TESTNET,
		decimals: 18,
		rpc: process.env.RPC_STARKNET_GOERLI || '',
		explorerUrl: 'https://testnet.starkscan.co/'
	}
};

const VALID_CHAIN_IDS: INetwork['chainId'][] = Object.values(NETWORKS_DATA)
	.map((n: INetwork) => n.chainId || 0)
	.filter((n): boolean => n !== 0);

export {
	CONNECTED_WEB3_ACCOUNTS_KEY,
	NETWORKS_DATA,
	SAVED_USER_ADDRESS_KEY,
	VALID_CHAIN_IDS,
	WALLETS,
	WALLETS_ARRAY,
	defaultProvider
};
